module.exports = __webpack_public_path__ + "img/img-1.f744799c.webp";